import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { CoreApiClient } from "../client";
import type { Alarm, GetAlarmEventsQuery, GetAlarmEventsResponseBody } from "../types/alarm.type";

export type AlarmEventsFilters = Omit<GetAlarmEventsQuery, "page">;

export const createAlarmQueries = (api: CoreApiClient) => {
  const { client } = api;

  const list = async (buildingId: string): Promise<Alarm[]> => {
    const { data, error } = await client.GET("/buildings/{buildingId}/alarms", {
      params: { path: { buildingId } },
    });
    if (error) throw new Error(error.message);
    return data;
  };

  const events = async (
    buildingId: string,
    filters: AlarmEventsFilters,
    page: number,
  ): Promise<GetAlarmEventsResponseBody> => {
    const { data, error } = await client.GET("/buildings/{buildingId}/alarm-events", {
      params: { path: { buildingId }, query: { ...filters, page } },
    });
    if (error) throw new Error(error.message);
    return data;
  };

  return {
    list,
    events,
    queries: createQueryKeys("alarm", {
      list: (buildingId: string) => ({
        queryKey: [buildingId],
        queryFn: () => list(buildingId),
      }),
      events: (buildingId: string, filters: AlarmEventsFilters) => ({
        queryKey: [buildingId, filters],
        queryFn: ({ pageParam }: { pageParam: number }) => events(buildingId, filters, pageParam),
      }),
    }),
  };
};
